/*
 *@Author: 史泽
 *@Date: 2022-01-17 10:00:57
 *@Description: 渠道 【首页->资料下载->横向滚动轮播】
*/
<template>
  <div class="DownloadDataSwiperCss">
    <div class="DownloadDataListTop">
      <div class="DownloadDataList">
        <div class="ListSwiper">
          <div ref="list" class="List" v-for="(item,index) in SwiperList" :key="index" :style="[{ transform: 'translateX('+ transforms +'px ) ' }]">
            <!-- <div class="ListTitle">{{ item.Attachment.FileName }}</div> -->
            <div class="ListTitle">{{ item.Title }}</div>
            <div class="Name"> <img src="../../../../../../../assets/channel/homePng/listPer.png" alt=""> {{ item.CreatorName }}</div>
            <div class="Download" @click="Download(item.Attachment)">
              下载
            </div>
            <div class="DownloadDataSee" @click="SeeDownload(item.Title)">
              查看
            </div>
          </div>
        </div>
      </div>
      <div class="left" @click="leftClick">
        <img src="../../../../../../../assets/channel/homePng/left.png" alt="">
      </div>
      <div class="right" @click="rightClick">
        <img src="../../../../../../../assets/channel/homePng/right.png" alt="">
      </div>
    </div>

  </div>
</template>

<script>

export default {
  components: {},
  props: {
    // 轮播数据
    SwiperList: {
      type: Array
    }
  },
  data() {
    return {
      onchang: 4,
      transforms: 0,
    }
  },
  created() {
    // this.DataDownloadListApi()
  },
  mounted() {

  },
  activated() { },
  updated() { },
  methods: {
    // 左切换
    leftClick() {
      if (this.onchang < this.SwiperList.length) {
        this.onchang++
        this.transforms = this.transforms - 300
      } else {
        this.$notify.warning({
          title: '提醒',
          message: '没有数据了'
        })
      }
      console.log(this.SwiperList.length, this.onchang, '第二次');

    },
    // 右切换
    rightClick() {
      if (this.onchang > 4) {
        this.onchang--
        this.transforms = this.transforms + 301
      } else {
        this.$notify.warning({
          title: '提醒',
          message: '没有数据了'
        })
      }
      console.log(this.SwiperList.length, this.onchang, '第二次');
    },
    // 下载文件
    Download(item) {
      if (item.Extension == 'pdf') {
        window.open(item.FileUrl, "_blank")
        return
      }
      window.location.href = item.FileUrl
    },
    
    SeeDownload(title) {
      this.$router.push({
        path: JSON.parse(localStorage.getItem("MenusData")).CusWebMenus.filter(item => item.NodeID == 65)[0].Path,
        query: {
          title: title
        }
      })
    }
  },
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
.DownloadDataSwiperCss {
  min-width: 1200px;
  height: 170px;
  user-select: none;
  // border: 1px solid #fff;
  overflow: hidden;

  .DownloadDataListTop {
    width: 1200px;
    min-width: 1200px;
    white-space: nowrap;
    // border: 1px solid red;
    margin: 0 auto;
    position: relative;
  }
  .DownloadDataList {
    width: 1200px;
    // white-space: nowrap;
    // border: 1px solid red;
    margin: 0 auto;

    .ListSwiper {
      max-width: 100%;
      overflow: hidden;
      // border: 2px solid palegoldenrod;
    }

    .List:nth-child(1) {
      margin-left: 8px;
    }
    .List {
      display: inline-block;
      // position: relative;
      margin-left: 16px;
      width: 283px;
      height: 170px;
      // overflow: hidden;
      background: url("../../../../../../../assets/channel/homePng/DownloadLsit.png")
        no-repeat 0px 0px;
      background-size: 100%;
      transition: all 0.3s linear;

      .ListTitle {
        width: 240px;
        height: 44px;
        color: #16181a;
        font-size: 16px;
        // border: 1px solid red;
        // border: 1px solid #fff;
        font-weight: bold;
        padding: 20px 0 0 20px;
        white-space: normal;
      }
      .Name {
        font-size: 14px;
        color: #424e66;
        position: relative;
        left: 15px;
        top: 15px;
      }
      .Name img {
        vertical-align: middle;
      }
      .Download {
        width: 130px;
        height: 36px;
        border: 1px solid #e65068;
        display: inline-block;
        color: #e65068;
        font-size: 14px;
        text-align: center;
        line-height: 36px;
        position: relative;
        top: 35px;
        left: 5px;
        user-select: none;
        cursor: pointer;
      }
      .DownloadDataSee {
        width: 130px;
        height: 38px;
        background-color: #e65068;
        color: #fff;
        display: inline-block;
        font-size: 14px;
        text-align: center;
        line-height: 36px;
        position: relative;
        top: 35px;
        left: 15px;
        user-select: none;
        cursor: pointer;
      }
    }
  }
  .left {
    position: relative;
    left: -50px;
    top: -100px;
    cursor: pointer;
  }
  .right {
    position: relative;
    left: 50px;
    top: -100px;
    cursor: pointer;
  }
}
@keyframes lefts {
  100% {
    transform: translateX(-280px);
  }
}
</style>